module.exports = __webpack_public_path__ + "img/twitterx.55e183ed.svg";